import Vue from 'vue';

const annualText = (price, annual) => `${price} €/${annual ? 'an' : 'mois'}`;

const formatPrice = (price, annual) => {
  const formatted = parseFloat(price || 0)
    / parseFloat(annual ? 1.0 : 12.0);
  const fixed = formatted.toFixed(2);
  return (fixed || 0).toString().replace('.', ',');
};

const format = (price, annual) => {
  const formatted = formatPrice(parseFloat(price), annual);
  return annualText(formatted, annual);
};

// eslint-disable-next-line no-unused-vars
const spacingFormatPrice = (price) => parseFloat(price || 0).toString()
  .replace('.00', '')
  .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

Vue.filter('priceToMonth', (value) => format(value, false));
Vue.filter('priceToAnnual', (value) => format(value, true));
Vue.filter('formatPrice', (value, annual) => formatPrice(value, annual));
Vue.filter('spacingFormatPrice', (value) => spacingFormatPrice(value));
